import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32.331 9.435a3.973 3.973 0 0 0-2.83-2.778C27.007 6 17 6 17 6S6.993 6 4.498 6.657a3.972 3.972 0 0 0-2.83 2.778C1 11.886 1 17 1 17s0 5.114.669 7.565a3.973 3.973 0 0 0 2.829 2.778C6.994 28 17 28 17 28s10.006 0 12.502-.657a3.973 3.973 0 0 0 2.83-2.778C33 22.114 33 17 33 17s0-5.114-.669-7.565Z",
  fill: "red"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m13.8 22 8.314-4.8-8.314-4.8V22Z",
  fill: "#fff"
})));

export { SvgSmYoutube as default };
